import React, { useContext } from 'react';
import MuiModal from '@mui/material/Modal';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalContext } from '../../contexts/modal';

export default function Modal() {
  const { open, setOpen, content, title } = useContext(ModalContext);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MuiModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Paper
        sx={{
          backgroundColor: 'background.paper',
          boxShadow: 5,
          p: [2, 4, 3],
        }}
      >
        <Stack direction="column">
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
          {content}
        </Stack>
      </Paper>
    </MuiModal>
  );
}
